import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-tooltip-mat',
    templateUrl: './tooltip-mat.component.html',
    styleUrls: ['./tooltip-mat.component.scss'],
    standalone: false
})
export class TooltipMatComponent implements OnInit {
	@Input() typeInformation: string;
	@Input() type: string;
	@Input() position: string = 'above';

	@Input() text: string = '';

	constructor() {}

	ngOnInit(): void {
		if (this.typeInformation == 'subAreaVida') {
			this.text =
				'Este conteúdo estará disponível a todos mas será recomendado para quem tiver pontos de atenção nas sub-áreas assinaladas. Seja específico: quanto menos sub-áreas marcadas, maior a probabilidade de as recomendações irem para o usuário certo.';
		} else if (this.typeInformation == 'fired') {
			this.text = 'Número total de notificações enviadas.';
		} else if (this.typeInformation == 'read') {
			this.text = 'Notificações visualizadas pelo usuário na listagem do aplicativo.';
		} else if (this.typeInformation == 'click') {
			this.text = 'Quantidade de cliques recebidos nas telas de aviso da notificação.';
		} else if (this.typeInformation == 'text') {
			//
		}  
		else {
			this.text =
				'Caso alguma condição seja selecionada este conteúdo estará disponível apenas para usuários que tenham tais condições, não sendo acessíveis aos outros. Se você quer que o conteúdo esteja visível para todos, não marque nenhuma opção (mesmo que o conteúdo seja relativo a uma das condições).';
		}
	}
}
